// Shared by the loan + sub-company checklist tables. The Override column carries the
// override checkbox plus the (formerly separate) supervisor + date, stacked beside it.
export const overrideCellStyles = { display: 'flex', alignItems: 'flex-start', gap: '8px' };

export const overrideMetaStyles = { display: 'flex', flexDirection: 'column' };
